import { render } from "./ViewStudentFinalGradeDialog.vue?vue&type=template&id=2873731e"
import script from "./ViewStudentFinalGradeDialog.vue?vue&type=script&lang=js"
export * from "./ViewStudentFinalGradeDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__